import { useCallback, useMemo } from 'react';

import type { SidebarCardId } from 'components/conversation/components/sidebar/conversationSidebar.types';
import { useServerStorage } from 'utils/useServerStorage';

export function useCardVisibility(): {
  readonly hiddenCards: Set<SidebarCardId>;
  readonly toggleCardVisibility: (cardId: SidebarCardId) => void;
} {
  const storage = useServerStorage('user');

  const toggleCardVisibility = useCallback(
    (cardId: SidebarCardId) => {
      storage.set({
        conversation: (draft) => {
          const hidden = new Set(draft.sidebarHiddenCards ?? []);
          hidden.has(cardId) ? hidden.delete(cardId) : hidden.add(cardId);
          draft.sidebarHiddenCards = [...hidden];
        },
      });
    },
    [storage],
  );

  return useMemo(
    () => ({
      hiddenCards: new Set(storage.data.conversation?.sidebarHiddenCards ?? []),
      toggleCardVisibility,
    }),
    [storage.data.conversation?.sidebarHiddenCards, toggleCardVisibility],
  );
}
